import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, [_c(VTextField, {
    attrs: {
      "value": _vm.getByKey('chartOptions.dateTimeFormat'),
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.dateTimeFormat.label'),
      "persistent-hint": "",
      "hint": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.dateTimeFormat.hint'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "input": function ($event) {
        return _vm.setByKey('chartOptions.dateTimeFormat', $event);
      }
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c('core-button', {
    attrs: {
      "prepend-icon": "fa-code",
      "color": _vm.color,
      "outlined": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('open-code-editor');
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('Dashboards.components.widgetChartOptionsEditor.buttons.openCodeEditor.label')) + "\n      ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };